export default {"src":"/_next/static/media/404.a5d0683d.svg","height":377,"width":689,"blurWidth":0,"blurHeight":0};